import { render, staticRenderFns } from "./VoucherItem.vue?vue&type=template&id=b6a1f79e&scoped=true&"
import script from "./VoucherItem.vue?vue&type=script&lang=js&"
export * from "./VoucherItem.vue?vue&type=script&lang=js&"
import style0 from "./VoucherItem.vue?vue&type=style&index=0&id=b6a1f79e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a1f79e",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn});
